// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XZ-8","col":"styles_col__2pF_H"};